import moment from 'moment';
import sortByFullName from '../../../helpers/reactTable/sortMethods';

function sortDate(rowA, rowB) {
  const a = rowA?.original?.signupDate;
  const b = rowB?.original?.signupDate;

  return new Date(a) - new Date(b);
}

const columnsFixtures = {
  user: {
    Header: 'Name',
    accessor: 'user',
    sortType: sortByFullName,
    customFieldMapping: {
      tableAccessor: 'user',
      documentKey: 'fullName',
    },
  },
  role: {
    Header: 'Role',
    accessor: 'role',
    customFieldMapping: {
      tableAccessor: 'role',
      documentKey: 'role',
    },
  },
  signupDate: {
    Header: 'Signup date',
    accessor: 'signupDate',
    sortType: sortDate,
    customFieldMapping: {
      tableAccessor: 'signupDate',
      documentKey: 'createdAt',
    },
  },
  activeProjects: {
    Header: 'Total project count',
    accessor: 'activeProjectsCount',
    customFieldMapping: {
      tableAccessor: 'activeProjectsCount',
      documentKey: 'activeProjectsCount',
    },
    disableSortBy: true,
  },
  location: {
    Header: 'Location',
    accessor: 'location',
    disableSortBy: true,
  },
  contact: {
    Header: 'Contacts',
    accessor: 'contact',
    disableSortBy: true,
  },
};

function getColumns() {
  return Object.values(columnsFixtures);
}

function getExcelData(users) {
  if (!users?.length) return [];
  return users.map(({
    name,
    role,
    createdAt,
    lastLoggedInAt,
    address: {
      city,
      country,
      postalCode,
    } = {},
  }) => ({
    name,
    role,
    createdAt: moment(createdAt).format('DD MMM YYYY'),
    lastLoggedInAt: lastLoggedInAt ? moment(lastLoggedInAt).format('DD MMM YYYY') : 'Has not logged in yet',
    city,
    country,
    postalCode,
  }));
}

function getExcelColumns() {
  return ['Name', 'Role', 'Registered date', 'Last sign in date', 'City', 'Country', 'Postcode'];
}

export default {
  getColumns,
  getExcelData,
  getExcelColumns,
  columnsFixtures,
};
